export default __webpack_public_path__ + "static/media/slide-7.cc251733.gif";